import { render } from "./Popup.vue?vue&type=template&id=27d7ae1c&scoped=true&ts=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=27d7ae1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d7ae1c"]])

export default __exports__